import {Box, Card, CardContent, Typography} from "@mui/material";
import {collectionCardSx} from "./collectionCardStyles";

export const StatCard = ({label, value, icon, bg}) => (
    <Card sx={collectionCardSx}>
        <CardContent sx={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
            <Box>
                <Typography fontSize={12} color="text.secondary">{label}</Typography>
                <Typography fontSize={28} sx={{mt: 0.5}}>{value}</Typography>
            </Box>
            <Box sx={{width: 40, height: 40, borderRadius: 2,
                display: "flex", alignItems: "center", justifyContent: "center"}}>
                {icon}
            </Box>
        </CardContent>
    </Card>
);
